import MarketPlaceBrandingManager from './brand-manager'
import CreateBrandingModule from './create-brand'

export const Modules = {
  'marketplace-branding:manager': MarketPlaceBrandingManager,
  'marketplace-branding:create': CreateBrandingModule,
}
